<template>
    <step-container :compact="true">
        <step-info
            :label="$t('V3_STEP_REVIEW')"
        >
        </step-info>

        <form-fields>
            <form-fields-main-scroll>
                <div class="cz3__review-totals">
                    <div class="cz3__review-quantity">
                        <span class="cz3__review-quantity__label">
                            {{$t('V3_QTY')}}
                        </span>

                        <multiselect
                            class="cz3__quantity-select"
                            v-model="selectedQuantity"
                            :options="quantityOptions"
                            :searchable="false"
                            :show-labels="false"
                            :allowEmpty="false"
                            placeholder=""
                        >
                            <template #noResult>
                                <span>&mdash;</span>
                            </template>
                        </multiselect>
                    </div>

                    <div class="cz3__review-total">
                        <span class="cz3__review-quantity__label">
                            {{$t('V3_TOTAL')}}
                        </span>

                        <div class="cz3__review-totals__info">
                            <span class="font-bold uppercase flex items-center">
                                <span class="text-2xl ml-2">
                                    {{defaultSubtotalPrice}}
                                </span>
                                <!-- <span class="text-sm uppercase text-gray-400 ml-2">total</span> -->
                            </span>

                            <span class="cz3__flex !hidden">
                                <span class="px-2 cz3__hide-sm">=</span>

                                <span class="font-bold uppercase flex items-center">
                                    <span class="px-2 cz3__hide-lg">=</span>

                                    <span class="text-2xl">
                                        {{defaultUnitPriceFormatted}}
                                    </span>
                                    <span class="text-sm uppercase text-gray-400 ml-2 cz3__hide-sm">base</span>
                                </span>

                                <template v-if="personalizations > 0">
                                    <span class="px-2 cz3__hide-sm">+</span>

                                    <span class="flex items-center">
                                        <span class="cz3__hide-lg ml-2">+</span>

                                        <span class="text-blue-500 text-2xl">
                                            <span v-if="freePersonalizations > 0" class="text-red-500 text-2xl">{{$t('FREE')}}</span>
                                            <span v-if="freePersonalizations > 0 && personalizations > freePersonalizations" class="px-1">+</span>
                                            <span v-if="personalizations > freePersonalizations">{{customizationsPrice}}</span>
                                        </span>
                                        <span class="text-sm uppercase text-gray-400">{{personalizationTitle}}</span>
                                    </span>
                                </template>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="cz3__review-line"></div>

                <toolbar-buttons :justify="true">
                    <!--
                    <icon-button
                        :label="$t('V3_REVIEW_SAVE')"
                        :disabled="savedRecipe == null"
                        :important="true"
                        @click="save"
                    >
                        <img src="../../assets/v2/review-save.svg" />
                    </icon-button>
                    -->

                    <icon-button
                        v-for="proof in proofs"
                        :key="proof.name"
                        :label="proofs.length > 1 ? proof.name.toUpperCase() : $t('V3_REVIEW_PROOF')"
                        :aria-label="proofs.length > 1 ? proof.name.toUpperCase() : $t('V3_REVIEW_PROOF')"
                        :disabled="savedRecipe == null"
                        :important="true"
                        @click="download(proof)"
                    >
                        <img src="../../assets/v2/review-download.svg" />
                    </icon-button>

                    <!--
                    <icon-button
                        :label="$t('V3_REVIEW_SHARE')"
                        :disabled="savedRecipe == null"
                        :important="true"
                        @click="share"
                    >
                        <img src="../../assets/v2/review-share.svg" />
                    </icon-button>
                    -->
                </toolbar-buttons>
            </form-fields-main-scroll>

            <step-buttons>
                <secondary-button
                    class="cz3__flex-1"
                    :label="$t('V3_BACK')"
                    @click="back"
                />

                <action-button
                    class="cz3__flex-1"
                    :label="addToCartLabel"
                    @click="next"
                />
            </step-buttons>
        </form-fields>
    </step-container>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__review-totals {
            display: flex;

            gap: 16px;
        }

        .cz3__review-line {
            flex: 0 0 auto;

            height: 0px;

            border: 1px solid #ebebeb;
        }

        .cz3__review-quantity {
            flex: 1 1 0;

            display: flex;
            flex-direction: column;

            justify-content: flex-start;
            align-items: flex-start;

            gap: 16px;
        }

        .cz3__review-total {
            flex: 1 1 0;

            display: flex;
            flex-direction: column;

            justify-content: flex-start;
            align-items: flex-end;

            gap: 16px;

            text-align: right;
        }

        .cz3__review-totals__info {
            font-family: $font-main;
            font-weight: 700;
            font-size: 20px;
            line-height: 48px;

            color: #000;

            display: flex;

            @include respond-below(sm) {
                flex-direction: column;
                align-items: flex-end;
            }
        }

        .cz3__price-discount {
            margin-right: 10px;

            font-weight: 400;
            color: #b9b9b9;

            text-decoration: line-through;
        }

        .cz3__review-quantity__label {
            font-family: $font-main;
            font-weight: 500;
            font-size: 14px;
        }

        .multiselect.cz3__quantity-select {
            width: 120px;

            background: #f5f5f5;
            border-radius: 8px;
            border: none;

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }

            .multiselect__tags {
                min-height: 48px;

                background: #f5f5f5;
                border-radius: 8px;
                border: none;
            }

            .multiselect__select {
                height: 48px;
            }

            .multiselect__single {
                font-family: $font-main;
                font-weight: 500;
                font-size: 16px;

                border-radius: 0;

                padding: 0;
                padding-left: 5px;
                margin-bottom: 0;

                vertical-align: middle;

                min-height: 1px;
                height: auto;
                line-height: 2;

                background: transparent;
            }

            .multiselect__input {
                font-family: $font-main;
                font-weight: 500;
                font-size: 16px;
                line-height: 28px;

                margin-bottom: 0;
                background: transparent;
            }

            .multiselect__option.multiselect__option--highlight {
                background: #f1f1f1;
                color: #000;
            }

            .multiselect__content-wrapper {
                border-radius: 8px;

                background: #fff;
                border: 1px solid #ccc;

                z-index: 100000;

                max-height: 175px !important;
            }

            &.multiselect--above {
                .multiselect__content-wrapper {
                    margin-top: -5px;
                }
            }
        }
    }
</style>

<script>
    import Cookies from 'js-cookie';
    import axios from 'axios';
    import FileSaver from 'file-saver';

    import StepContainer from './StepContainer.vue';
    import StepInfo from './StepInfo.vue';
    import FormFields from './FormFields.vue';
    import FormFieldsMainScroll from './FormFieldsMainScroll.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import IconButton from './IconButton.vue';
    import StepButtons from './StepButtons.vue';
    import ToolbarButtons from './ToolbarButtons.vue';

    export default {
        components: {
            StepContainer,
            StepInfo,
            FormFields,
            FormFieldsMainScroll,
            ActionButton,
            SecondaryButton,
            StepButtons,
            IconButton,
            ToolbarButtons,
        },

        props: {
        },

        data() {
            return {
                savedRecipe: null,

                selectedQuantity: null,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Can we build this configuration?
             */
            canBuild() {
                return this.$store.getters.canBuild;
            },

            selectedStep() {
                return this.$store.state.selectedStepV3;
            },

            prevStep() {
                return this.$store.getters.prevStepV3;
            },

            addToCartLabel() {
                if (this.$store.state.customizer.options.recipe && this.$store.state.customizer.options.recipe !== 'null') {
                    return this.$t('V3_UPDATE_CART');
                }

                return this.$t('V3_ADD_TO_CART');
            },

            quantity() {
                return this.$store.state.customizer.quantity;
            },

            maxQuantity() {
                return this.$store.getters.availableQuantity;
            },

            quantityOptions() {
                const options = [];

                for (let i = 1; i <= this.maxQuantity; i += 1) {
                    options.push(i);
                }

                return options;
            },

            proofs() {
                const views = [];

                const dependentViews = [];

                this.viewController.blueprint.views.forEach((v) => {
                    if (v.custom && v.custom['v-also-show']) {
                        dependentViews.push(v.custom['v-also-show']);
                    }
                });

                // eslint-disable-next-line prefer-const
                let onlySides = null;

                // if (this.personalizationMethod === 'etching') {
                //     const designOn = this.viewController.blueprint.custom['v-design-on'];

                //     if (designOn) {
                //         const sides = designOn.split(',').map((x) => x.trim());

                //         if (this.viewController.blueprint.custom['v-etch-either-side'] === 'true') {
                //             const preferred = this.viewController.blueprint.custom['v-preferred-side-v3'];

                //             if (preferred && sides.includes(preferred)) {
                //                 onlySides = preferred;
                //             }
                //         }

                //         if (onlySides == null) {
                //             if (sides.includes('back')) {
                //                 onlySides = 'back';
                //             }
                //         }

                //         if (onlySides == null) {
                //             if (sides.includes('front')) {
                //                 // eslint-disable-next-line no-unused-vars
                //                 onlySides = 'front';
                //             }
                //         }
                //     }
                // }

                this.viewController.blueprint.views.forEach((view) => {
                    if (dependentViews.includes(view.code)) {
                        return;
                    }

                    if (onlySides && view.custom['v-design-area']) {
                        if (view.custom['v-design-area'] !== onlySides) {
                            return;
                        }
                    }

                    if (!view.productionReady && view.bakeInRecipe) {
                        let bakedFrame;

                        if (view.bakedFrame) {
                            ({ bakedFrame } = view);
                        } else {
                            if (view.viewType === 'Single') {
                                bakedFrame = view.frameLow;
                            }
                            if (view.viewType === 'Range') {
                                bakedFrame = view.frameLow;
                            }
                        }

                        let url = this.viewController.makeFrameUrl(view, this.viewController.state, bakedFrame, {
                            baking: true,
                        });

                        url += '&fmt=jpg&qlt=95';

                        url = url.replace('rhei=600&', '');
                        url = url.replace('rwid=500&', '');

                        views.push({
                            name: view.name,
                            url,
                        });
                    }
                });

                return views;
            },

            subtotalPrice() {
                return this.$store.state.customizer.subtotalPrice;
            },

            defaultSubtotalPrice() {
                return this.$store.state.customizer.defaultSubtotalPrice;
            },

            isDiscounted() {
                return this.subtotalPrice !== this.defaultSubtotalPrice;
            },

            filledPlacements() {
                return this.$store.getters.filledPlacements;
            },

            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            selectedStepV3() {
                return this.$store.state.selectedStepV3;
            },

            defaultUnitPriceFormatted() {
                return this.$store.getters.defaultUnitPriceFormatted;
            },

            personalizations() {
                return this.$store.state.customizer.personalizations;
            },

            freePersonalizations() {
                return this.$store.state.customizer.freePersonalizations;
            },

            customizationsPrice() {
                return this.$store.state.customizer.customizationsPrice;
            },

            personalizationTitle() {
                return this.viewController.blueprint.custom['v-personalization-product-title'];
            },
        },

        watch: {
            selectedQuantity() {
                this.$store.dispatch('setQuantity', this.selectedQuantity);
            },

            savedRecipe() {
                let url = new window.URL(window.location.href);

                url.searchParams.delete('edit');
                url.searchParams.append('edit', this.savedRecipe.recipe.id);

                url = url.toString();

                window.history.replaceState(null, null, url);
            },
        },

        beforeMount() {
        },

        mounted() {
            this.selectedQuantity = this.quantity;

            this.$store.dispatch('lockSwipe', false);
            this.$store.dispatch('editPlacement', null);

            // Find the first design and go to that view
            // eslint-disable-next-line no-restricted-syntax
            for (const p of this.filledPlacements) {
                if (p.component.custom['v-design-on']) {
                    this.$store.dispatch('switchToDesignView', p.component.custom['v-design-on']);
                    break;
                }
            }

            // Save a recipe here to be able to share synchronously later.
            this.$store.dispatch('customizerDone', {
                saveOnly: true,
                noBusy: true,
            }).then((recipe) => {
                this.savedRecipe = recipe;
            });
        },

        beforeDestroy() {
        },

        methods: {
            back() {
                this.$store.dispatch('setSelectedStepV3', this.prevStep);
            },

            next() {
                let actualFilledTextPlacements = 0;

                this.$store.getters.textPlacements.forEach((c) => {
                    if (c.component.custom
                        && c.component.custom['personalization-text']
                        && c.component.custom['personalization-text'].trim().length > 0) {
                        actualFilledTextPlacements += 1;
                    }
                });

                if (actualFilledTextPlacements === 0
                    && this.$store.getters.filledMonogramPlacements.length === 0
                    && this.$store.getters.filledImagePlacements.length === 0) {
                    this.$store.dispatch('showGenericNotify', {
                        title: this.$t('NO_PERSONALIZATIONS'),
                        description: this.$t('NO_PERSONALIZATIONS_BODY'),
                        action: this.$t('ACTION_CONTINUE'),
                    });
                } else if (this.canBuild) {
                    if (Cookies.get('CUSTOM-TOS') === 'accepted') {
                        this.$store.dispatch('customizerDone');
                    } else {
                        this.$store.dispatch('showTosConfirmation', true);
                    }
                }
            },

            save() {
                // Need a recipe to share it
                if (!this.savedRecipe) {
                    return;
                }

                this.$store.dispatch('saveWishlist', {
                    id: this.savedRecipe.recipe.id,
                });
            },

            download(view) {
                const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                if (isIos) {
                    window.open(view.url);
                } else {
                    axios.get(view.url, { responseType: 'blob' }).then((response) => {
                        let name;

                        if (this.isGroupOrder) {
                            name = `Proof-${this.selectedBottleIndex}-${view.name}.jpg`;
                        } else {
                            name = `Proof-${view.name}.jpg`;
                        }

                        FileSaver.saveAs(response.data, name);
                    });
                }
            },

            share() {
                // Need a recipe to share it
                if (!this.savedRecipe) {
                    return;
                }

                let url = new window.URL(window.location.href);

                url.searchParams.delete('edit');
                url.searchParams.append('edit', this.savedRecipe.recipe.id);

                url = url.toString();

                if (navigator.share) {
                    navigator.share({
                        url,
                    });
                } else {
                    window.location.href = `mailto:?body=${encodeURIComponent(url)}`;
                }
            },

            help() {
            },
        },
    };
</script>
